import { useQuery, useQueryClient } from "@tanstack/react-query";
import { confirmAction } from "@/components/app/Confirm";
import { Trash2, Library } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { EmptyState, SkeletonRows } from "@/components/app/Common";
import { api, get, errMsg } from "@/lib/api";

export default function TaskLibrary() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["ws-library"], queryFn: () => get("/work-sample-library") });
  const del = async (id) => { try { await api.delete(`/work-sample-library/${id}`); qc.invalidateQueries({ queryKey: ["ws-library"] }); toast.success("Removed"); } catch (e) { toast.error(errMsg(e)); } };
  if (isLoading) return <SkeletonRows rows={3} />;
  return (
    <div className="space-y-4" data-testid="task-library-page">
      <div><h2 className="text-lg font-semibold">Task library</h2><p className="text-sm text-ink-secondary">Approved work-sample tasks saved for reuse. Load one from any job's Work samples tab.</p></div>
      {!data.length ? <EmptyState icon={Library} title="No saved tasks" text="Use 'Save to library' on a job's work-sample task." testId="task-library-empty" /> : (
        <ul className="space-y-2">{data.map((t) => (
          <li key={t.id} className="panel flex items-center gap-4 p-4" data-testid={`library-item-${t.id}`}>
            <div className="flex-1"><p className="font-medium">{t.name}</p><p className="text-xs text-ink-muted">{t.task_type.replace("_", " ")} · {t.variants.length} variant(s) · from {t.source_job}</p></div>
            <Button size="sm" variant="ghost" onClick={async () => (await confirmAction({ title: "Remove from the library?", body: "Jobs that already use this task keep their copy.", entity: t.title || "Library task", confirmLabel: "Remove" })) && del(t.id)} data-testid={`library-delete-${t.id}`}><Trash2 size={14} /></Button>
          </li>
        ))}</ul>
      )}
    </div>
  );
}
